import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const CylindricalTripleIntegration = () => (
  <QPhototModuleSubtopic
    title="Using cylindrical coordinates for triple integration"
    videos={[
      "https://www.youtube.com/embed/FAihln6nIHw",
      "https://www.youtube.com/embed/f5Akpla9Rfk",
      "https://www.youtube.com/embed/94bCRXqyQLc"
    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_51.jpeg"
        }
    ]}
    exampleVideos={[]}
  />
);

export default CylindricalTripleIntegration;
